import React, { useContext } from 'react';
import { APIContext } from '../contexts/APIContext';

const AuthorisationError = () => {
  const { expiryFlag } = useContext(APIContext);
  return (
    <div className="relative bg-white flex items-center justify-center h-screen">
      <div className="text-center">
        <img src="/icons/contact.svg" alt="contact" className="mx-auto" />
        <p className="text-base">
          {expiryFlag === false
            ? 'Temporary access for you to view this module has expired.'
            : 'You are not authorised to view Generative Market Analysis'}
        </p>
        <p className="text-sm">
          Click{' '}
          <a
            href="mailto:GMA.AccessSupport@accenture.com?subject=GMA%20Application%20Access%20Request&body=Hello%20team,%0D%0A%0D%0AI%20would%20like%20to%20request%20access%20to%20GMA,%20please%20find%20the%20requirement%20details%20below.%20I%20understand%20that%20if%20I%20do%20not%20complete%20the%20form%20below,%20my%20request%20will%20not%20be%20processed.%0D%0A%0D%0AGenerative%20Market%20Analysis%20has%20limited%20access%20to%20our%20Corporate%20Strategy%20%26%20Growth%20(CS%26G)%20practice.%0D%0AHave%20you%20been/%20will%20be%20open%20to%20working%20with%20someone%20from%20the%20CS%26G/%20growth%20strategy%20group%20for%20this%20proposal/project?%20(Y/N)%0D%0AIs%20this%20a%20growth%20strategy%20or%20market%20research%20opportunity?%20(Y/N)%0D%0AProject%20scope:%20please%20describe%0D%0AEIDs%20for%20access:%20please%20provide%0D%0AProject%20Lead%20EID:%0D%0AClient%20Name:%20please%20provide%0DIs%20this%20a%20proposal%20or%20project%20delivery?%0D%0AGeography/country:%20please%20provide%0D%0AMarket%20Unit:%20please%20provide%0D%0AHow%20long%20do%20you%20need%20to%20use%20GMA?%0D%0A%0D%0AThank%20you!"
            className="text-purple-600 underline"
          >
            here
          </a>{' '}
          to request access
        </p>
      </div>
    </div>
  );
};

export default AuthorisationError;
